import { Injectable } from '@angular/core';
import { RequestState } from '@shared/models/request-state';
import { DecsService } from '@shared/services/decs/decs.service';
import { DecsRequest } from '@shared/services/decs/models/request/decs.request';
import { DecsResponse } from '@shared/services/decs/models/response/decs.response';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AircraftService {
  constructor(private decsService: DecsService) {}

  /** Use the Sabre command RGMN[acft_num] to get MEL list (text). */
  getMels(
    aircraftNumber: string,
    isRefresh = false
  ): Observable<RequestState<DecsResponse>> {
    const decsRequest: DecsRequest = {
      cmd: `RGMN${aircraftNumber}`,
    };

    return this.decsService.submitDecsRequest(decsRequest, isRefresh);
  }

  /** Get aircraft routing from Sabre command RGA [acft_num]/F (text). */
  getRouting(
    aircraftNumber: string,
    isRefresh = false
  ): Observable<RequestState<DecsResponse>> {
    const decsRequest: DecsRequest = {
      cmd: `RGA ${aircraftNumber}/F`,
    };

    return this.decsService.submitDecsRequest(decsRequest, isRefresh);
  }
}
